<template>
  <div class="contents">
    <div class="wrap">
      <section>
        <h2 class="page_title --view">상세코드 신규 등록</h2>
      </section>
      <section>
        <article>
          <div class="table_list mb40">
            <table class="write">
              <colgroup>
                <col width="25%">
                <col width="25%">
                <col width="25%">
                <col width="25%">
              </colgroup>
              <tbody>
              <tr>
                <th><span>그룹코드</span></th>
                <td>{{ grpCode }}</td>
                <th><span>그룹코드명</span></th>
                <td>{{ grpCodeNm }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </article>
      </section>
      <section>
        <div class="table_list mb40">
          <table class="write">
            <colgroup>
              <col width="200">
              <col width="*">
            </colgroup>
            <tbody>
            <tr>
              <th><span>상세코드</span></th>
              <td>
                <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.dtlCode"
                       :readonly="readOnlyFlag">
              </td>
            </tr>
            <tr>
              <th><span>상세코드명</span></th>
              <td>
                <input type="text" class="form_control" placeholder="입력해주세요."
                       v-model="regData.dtlCodeNm">
              </td>
            </tr>
            <tr>
              <th><span>순서</span></th>
              <td>
                <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.order">
              </td>
            </tr>
            <tr>
              <th><span>사용유무</span></th>
              <td>
                <div class="form_inline">
                  <div class="form_radio">
                    <input type="radio" id="radio1" name="radio" value="Y" v-model="regData.useYn">
                    <label for="radio1">Y</label>
                  </div>
                  <div class="form_radio">
                    <input type="radio" id="radio2" name="radio" value="N" v-model="regData.useYn">
                    <label for="radio2">N</label>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th><span>상위그룹코드</span></th>
              <td>
                <div class="form_inline">
                  <input type="text" class="form_control limit" placeholder="입력해주세요."
                         v-model="regData.parentGrpCodeNm"
                         readonly>
                  <button class="btn btn_md btn_deepblue" v-b-modal.groupCodeSearch>검색</button>
                </div>
              </td>
            </tr>
            <tr>
              <th><span>상위상세코드</span></th>
              <td>
                <div class="form_inline">
                  <input type="text" class="form_control limit" placeholder="입력해주세요."
                         v-model="regData.parentDtlCodeNm"
                         readonly>
                  <button class="btn btn_md btn_deepblue" @click="fn_click_parent_detail_search">검색</button>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
          <div class="bottom_box">
            <button class="btn btn_md btn_outline" @click="fn_move_page">목록</button>
            <div class="btn_box">
              <!-- button class="btn btn_md btn_gray">취소</button -->
              <button class="btn btn_md btn_darkblue" @click="fn_reg">저장</button>
            </div>
          </div>
        </div>
      </section>
    </div>
    <groupCodeSearch
        :title="'상위 코드 검색'"
        :searchName="'그룹코드명'"
        :searchData="regData.parentGrpCodeNm"
        :oneBtn="true"
        :btnLeft="'적용'"
        :btnRight="'닫기'"
        @callback="fn_groupCode_callback"
    />
    <detailCodeSearch
        :title="'상위 상세 코드 검색'"
        :searchName="'상세코드명'"
        :searchGroupCode ="regData.parentGrpCode"
        :searchData="regData.parentDtlCodeNm"
        :oneBtn="true"
        :btnLeft="'적용'"
        :btnRight="'닫기'"
        @callback="fn_detailCode_callback"
    />
  </div>

</template>

<script>
import axios from 'axios'
import groupCodeSearch from "@/modal/admin/groupCodeSearch.vue";
import detailCodeSearch from "@/modal/admin/detailCodeSearch.vue";

export default {
  name: 'CodeMngtRegDtl',
  components: {groupCodeSearch,detailCodeSearch},
  data() {
    return {
      grpCode: '',
      grpCodeNm: '',
      regData: {
        grpCode: '',
        dtlCode: "",
        dtlCodeNm: "",
        parentGrpCode: "",
        parentGrpCodeNm: "",
        parentDtlCode: "",
        parentDtlCodeNm: "",
        order: "",
        useYn: "Y",
        status: "I"
      },
      readOnlyFlag: false
    }
  },
  created() {
    this.grpCode = this.$store.getters['codeMngt/getCode'];
    this.grpCodeNm = this.$store.getters['codeMngt/getCodeNm'];
    this.regData.grpCode = this.$store.getters['codeMngt/getCode'];
    this.regData.dtlCode = this.$store.getters['codeMngt/getDtlCode'];

    if (this.regData.dtlCode) {
      this.regData.status = "M";

      this.readOnlyFlag = true;

      this.fn_search_dtlCode();
    }
  },
  methods: {
    fn_reg() {

      console.log(this.parentGrpCode + " : " + this.parentDtlCode);

      if(this.regData.parentGrpCode != ''){
        if(this.regData.parentDtlCode == ''){
           alert("상위 상세코드를 입력해주세요.");
           return;
        }
      }

      axios.post("/api/system/regCodeDtl",
          this.regData
      ).then((res) => {
        console.log("@@@@ res : %o", res);
        this.$store.dispatch('codeMngt/setDtlCode', '');
        alert("저장되었습니다");
        this.fn_move_page();
      })
          .catch((err) => console.log(err));


    },
    fn_move_page() {
      this.$store.dispatch('codeMngt/setDtlCode', '');
      this.$router.push("/admin/system/codeMngt");
    },
    fn_search_dtlCode() {

      axios.post("/api/system/searchDetailCode",
          this.regData
      ).then((res) => {

        console.log("@@@@ res : %o", res);
        this.regData.dtlCodeNm = res.data.dtlCodeInfo.dtl_code_nm;
        this.regData.order = res.data.dtlCodeInfo.dtl_order;
        this.regData.useYn = res.data.dtlCodeInfo.use_yn;

        this.regData.parentGrpCode = res.data.dtlCodeInfo.parent_code;
        this.regData.parentGrpCodeNm = res.data.dtlCodeInfo.parent_grp_code_nm;
        this.regData.parentDtlCode = res.data.dtlCodeInfo.parent_dtl_code;
        this.regData.parentDtlCodeNm = res.data.dtlCodeInfo.parent_dtl_code_nm;


      })
          .catch((err) => console.log(err));
    },
    fn_groupCode_callback(groupCodeInfo) {
      this.regData.parentGrpCode = groupCodeInfo.code;
      this.regData.parentGrpCodeNm = groupCodeInfo.code_nm;

    },
    fn_click_parent_detail_search(){
        if(!this.regData.parentGrpCode){
            alert("상위 그룹코드를 선택해주세요.");
            return;
        }

        this.$bvModal.show('detailCodeSearch');
    },
    fn_detailCode_callback(detailCodeInfo){
        this.regData.parentDtlCode = detailCodeInfo.dtl_code;
        this.regData.parentDtlCodeNm = detailCodeInfo.dtl_code_nm;

    }
  }
}
</script>